import React from 'react'

const EllipsisVertical = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/ellipsis-vertical',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill={primaryColor}
      fillRule='evenodd'
      transform='translate(8 2)'
    >
      <circle cx={2} cy={14} r={2} />
      <circle cx={2} cy={8} r={2} />
      <circle cx={2} cy={2} r={2} />
    </g>
  </svg>
)

export default EllipsisVertical
